import React from 'react'

import { caretPositionForDigitCount, countDigitsBefore } from '@/utils/phone-number'

import { processNumericValue } from '../numeric-input/numeric-input.utils'
import { TextInput } from '../text-input'
import { CurrencyInputProps } from './currency-input.types'
import { formatThousands } from './currency-input.utils'

const DECIMAL_PLACES = 2

export const CurrencyInput = ({ min, max, value, onChange, ...props }: CurrencyInputProps) => {
  const displayValue = value ? formatThousands(value) : value

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target
    const typedValue = input.value.replace(/,/g, '')
    const newValue = processNumericValue(typedValue, value, 'decimal', DECIMAL_PLACES, min, max)

    // Note: the "Clear" button dispatches a synthetic event with a plain-object target (no DOM node),
    // so caret handling only applies to genuine input edits.
    if (input instanceof HTMLInputElement) {
      const formatted = formatThousands(newValue)
      const digitsBeforeCaret = countDigitsBefore(
        input.value,
        input.selectionStart ?? input.value.length,
      )
      const caret = caretPositionForDigitCount(formatted, digitsBeforeCaret)
      input.value = formatted
      input.setSelectionRange(caret, caret)
    }

    onChange(newValue)
  }

  return (
    <TextInput
      type="text"
      inputMode="decimal"
      leadingSlot="$"
      value={displayValue}
      onChange={handleChange}
      {...props}
    />
  )
}
